/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Subject_Sports13Inputs */

const en__field_enum_subject_sports13 = /** @type {(inputs: _Field_Enum_Subject_Sports13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sports`)
};

const de__field_enum_subject_sports13 = /** @type {(inputs: _Field_Enum_Subject_Sports13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sport`)
};

/**
* | output |
* | --- |
* | "Sports" |
*
* @param {_Field_Enum_Subject_Sports13Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_subject_sports13 = /** @type {((inputs?: _Field_Enum_Subject_Sports13Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Subject_Sports13Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_subject_sports13(inputs)
	return de__field_enum_subject_sports13(inputs)
});
export { _field_enum_subject_sports13 as "_field_enum_SUBJECT_SPORTS" }